import { render, staticRenderFns } from "./constructionPermitDetails.vue?vue&type=template&id=1a5575e4&scoped=true"
import script from "./constructionPermitDetails.vue?vue&type=script&lang=js"
export * from "./constructionPermitDetails.vue?vue&type=script&lang=js"
import style0 from "./constructionPermitDetails.vue?vue&type=style&index=0&id=1a5575e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5575e4",
  null
  
)

export default component.exports